import authFetch from './authFetch';

async function request(url, options) {
  const response = await authFetch(url, {
    cache: 'default',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    ...options,
  });
  if (!response.ok) {
    throw await response.json();
  }

  if (response.status === 204) {
    return;
  }

  const result = await response.json();
  if (result?.status === false) {
    throw new Error(result.message);
  }

  return result;
}

export default {
  fetch: async function() {
    return request('/api/children', {
      method: 'GET',
    });
  },
};
